import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { useAppContext } from '../AppContext';

const RealtimeCommentCount = ({ postId, contentType, nexusId }) => {
    const { db, appId } = useAppContext();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!postId || !contentType) return;

        let path;
        if (contentType === 'whisper') {
            path = `artifacts/${appId}/public/data/whispers/${postId}`;
        } else if (contentType === 'moment') {
            path = `artifacts/${appId}/public/data/moments/${postId}`;
        } else if (contentType === 'nexusPost' && nexusId) {
            path = `artifacts/${appId}/public/data/nexuses/${nexusId}/posts/${postId}`;
        } else {
            return;
        }

        const docRef = doc(db, path);
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                setCount(docSnap.data().commentsCount || 0);
            }
        });

        return () => unsubscribe();
    }, [db, appId, postId, contentType, nexusId]);

    return <span className="text-xs text-white drop-shadow-md">{count}</span>;
};

export default RealtimeCommentCount;
